/**
 * In-memory bet-history log. Port of
 *   packages/amgcommon_v2/lib/services/game_log_manager.dart.
 */

export interface GameLogEntry {
  id: string;
  betAmount: number;
  betDetails: string | null;
  winLoseAmount: number;
  balanceBefore: number;
  balanceAfter: number;
  gameResult: string;
  timestamp: number;
  roundId: string | null;
}

const MAX_ENTRIES = 50;

type Listener = () => void;

class GameLogManagerImpl {
  private _entries: GameLogEntry[] = [];
  private listeners: Set<Listener> = new Set();

  get entries(): ReadonlyArray<GameLogEntry> {
    return this._entries;
  }
  get count(): number {
    return this._entries.length;
  }
  get isNotEmpty(): boolean {
    return this._entries.length > 0;
  }

  add(partial: Omit<GameLogEntry, 'id' | 'timestamp'>): void {
    const entry: GameLogEntry = {
      ...partial,
      id: String(Date.now()) + ':' + Math.random().toString(36).slice(2, 6),
      timestamp: Date.now(),
    };
    this._entries.unshift(entry);
    if (this._entries.length > MAX_ENTRIES) {
      this._entries.length = MAX_ENTRIES;
    }
    this.emit();
  }

  clear(): void {
    if (this._entries.length === 0) return;
    this._entries = [];
    this.emit();
  }

  on(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private emit(): void {
    for (const l of this.listeners) {
      try {
        l();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[GameLogManager listener]', e);
      }
    }
  }
}

export const GameLogManager = new GameLogManagerImpl();
